@if (filteredItems) {
  <p-table
    #itemTable
    [globalFilterFields]="['entityType', 'action', 'user']"
    [loading]="loading"
    [paginator]="true"
    [sortField]="'createdAt'"
    [sortOrder]="-1"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [value]="filteredItems">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [showRangeFilter]="true"
        [searchWord]="searchWord"
        [fromDate]="fromDate"
        [toDate]="toDate"
        (clearTable)="clear(itemTable)"
        (fromDateChange)="onFromDateChange($event)"
        (toDateChange)="onToDateChange($event)"
        (search)="
          itemTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-database"></i> Was</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-bolt"></i> Aktion</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-calendar-day"></i> Wann</span
          >
        </th>
        <th>
          <span class="flex gap-2 align-items-center"
            ><i class="fas fa-user-circle"></i> Wer</span
          >
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <span class="flex gap-2 align-items-center">
            <i
              [class]="
                'entityTypes.' + item.entityType + '.icon' | translate
              "></i>
            {{ 'entityTypes.' + item.entityType + '.text' | translate }}
          </span>
        </td>
        <td>
          <span class="flex gap-3 align-items-center">
            <i [class]="'actions.' + item.action + '.icon' | translate"></i>
            {{ 'actions.' + item.action + '.text' | translate }}
          </span>
        </td>
        <td>
          <span class="flex gap-2 align-items-center">
            <i class="fas fa-calendar-day"></i>
            {{ item.createdAt * 1000 | date: "dd.MM.yyyy', ' HH:mm" }}
          </span>
        </td>
        <td>
          <span class="flex gap-2 align-items-center">
            <i class="fas fa-user-circle"></i>
            {{
              userStore.getById(item.user)?.username ||
                'Benutzer nicht gefunden'
            }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine History gefunden</span>
    </div>
  </div>
}
